"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountdownFromTimestamp = exports.getCountdownFromDuration = void 0;
/**
 * @dev Returns a countdown object or string from a duration in milliseconds
 * @param duration: the duration in milliseconds
 * @param inDays: whether or not to include days in the countdown
 * @param asString: whether or not to return a string or an object
 * @returns a countdown object or string
 */
function getCountdownFromDuration(duration, inDays = true, asString = true) {
    const countdown = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    };
    const countdownStrings = {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00',
    };
    if (duration > 0) {
        if (inDays) {
            countdown.days = Math.floor(duration / (1000 * 60 * 60 * 24));
            duration -= countdown.days * (1000 * 60 * 60 * 24);
        }
        countdown.hours = Math.floor(duration / (1000 * 60 * 60));
        duration -= countdown.hours * (1000 * 60 * 60);
        countdown.minutes = Math.floor(duration / (1000 * 60));
        duration -= countdown.minutes * (1000 * 60);
        countdown.seconds = Math.floor(duration / 1000);
        duration -= countdown.seconds * 1000;
        for (const e in countdown) {
            // @dev: pad with a leading 0 if the number is less than 10
            if (countdown[e] < 10) {
                countdownStrings[e] = `0${countdown[e]}`;
            }
            else {
                countdownStrings[e] = countdown[e].toString();
            }
        }
    }
    if (asString) {
        if (inDays) {
            return `${countdownStrings.days}D : ${countdownStrings.hours}H : ${countdownStrings.minutes}M : ${countdownStrings.seconds}S`;
        }
        return `${countdownStrings.hours}H : ${countdownStrings.minutes}M : ${countdownStrings.seconds}S`;
    }
    return countdown;
}
exports.getCountdownFromDuration = getCountdownFromDuration;
function getCountdownFromTimestamp(endTimestamp, inDays = true, asString = true, offset = 0) {
    if (endTimestamp instanceof Date) {
        endTimestamp = endTimestamp.getTime();
    }
    const duration = Math.max(endTimestamp - (Date.now() + offset), 0);
    return getCountdownFromDuration(duration, inDays, asString);
}
exports.getCountdownFromTimestamp = getCountdownFromTimestamp;
//# sourceMappingURL=countdown.js.map